import { useState } from 'react';
import { BaseButton } from '../../../../components/UI/BaseButton';
import { CustomSelect } from '../../../../components/UI/CustomSelect';
import Workspace, { WorkspaceEstimationType } from '../../../../types/Workspace';
import CustomTooltip from '../../../../components/UI/Tooltip/CustomTooltip';

export type SpaceSettingsPropertiesProps = {
  space?: Workspace;
  onSave: (estimationType: WorkspaceEstimationType) => void;
  setIsChanged?: (isChanged: boolean) => void;
  isDisabled?: boolean;
};

export const SpaceSettingsProperties = ({ space, onSave, setIsChanged, isDisabled }: SpaceSettingsPropertiesProps) => {
  const [selectedEstimationType, setSelectedEstimationType] = useState<WorkspaceEstimationType>(
    space?.estimationType || WorkspaceEstimationType.storyPoints
  );
  const isChanged = space?.estimationType !== selectedEstimationType;

  const handleUpdateEstimationType = (estimationType: WorkspaceEstimationType) => {
    setSelectedEstimationType(estimationType);
    setIsChanged && setIsChanged(estimationType !== space?.estimationType);
  };

  return (
    <div className="w-full h-full px-8 flex flex-col items-start justify-between">
      <div className="flex flex-col items-start gap-2 mt-6">
        <div className="text-brand-grey-dark text-base font-semibold">Properties</div>

        <div className="w-full flex flex-col items-start gap-2 mt-4">
          <div className="text-brand-grey-dark text-xs font-semibold leading-none">Estimation Framework</div>
          <CustomSelect
            options={[WorkspaceEstimationType.storyPoints, WorkspaceEstimationType.tshirtSizes].map((type) =>
              getTitle(type)
            )}
            selectedOption={getTitle(selectedEstimationType)}
            selectOption={(option) => handleUpdateEstimationType(getEstimationType(option))}
            width="320px"
          />
        </div>
      </div>

      {isDisabled && (
        <CustomTooltip title={'You cannot change the teamspace properties'}>
          <div className="absolute top-[80px] left-[250px] w-[calc(100%-250px)] h-[calc(100%-80px)] bg-white/30 z-10 cursor-not-allowed pointer-events-auto" />
        </CustomTooltip>
      )}

      <div className="w-full flex justify-end items-center mb-3">
        <BaseButton type="primary" size="medium" disabled={!isChanged} onClick={() => onSave(selectedEstimationType)}>
          Save Changes
        </BaseButton>
      </div>
    </div>
  );
};

const getTitle = (estimationType: WorkspaceEstimationType) => {
  switch (estimationType) {
    case WorkspaceEstimationType.storyPoints:
      return 'Story Points (1, 2, 3, 5, 8, 13, 21)';
    case WorkspaceEstimationType.tshirtSizes:
      return 'T-shirt Sizes (XS, S, M, L, XL)';
  }
};

const getEstimationType = (title: string): WorkspaceEstimationType => {
  switch (title) {
    case 'Story Points (1, 2, 3, 5, 8, 13, 21)':
      return WorkspaceEstimationType.storyPoints;
    case 'T-shirt Sizes (XS, S, M, L, XL)':
      return WorkspaceEstimationType.tshirtSizes;
    default:
      return WorkspaceEstimationType.storyPoints;
  }
};
